var React = require('react');

function VerySmallChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"VerySmallChevronRight","opacity":"0.3"},React.createElement("path",{"id":"Vector 416 (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M3.96967 0.96967C4.26256 0.676777 4.73744 0.676777 5.03033 0.96967L10.0607 6L5.03033 11.0303C4.73744 11.3232 4.26256 11.3232 3.96967 11.0303C3.67678 10.7374 3.67678 10.2626 3.96967 9.96967L7.93934 6L3.96967 2.03033C3.67678 1.73744 3.67678 1.26256 3.96967 0.96967Z","fill":"#E8EFFF"})));
}

VerySmallChevronRight.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = VerySmallChevronRight;

VerySmallChevronRight.default = VerySmallChevronRight;
